import styled, { createGlobalStyle } from 'styled-components'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { postApi } from '@api/api'
import { useUserContext } from '@hooks/useUserContext'
import axios from 'axios'
import { useHistory } from 'react-router'
import PropTypes from 'prop-types'
import CommonText from '@components/common/CommonText'
import CommonIconButton from '@components/common/CommonIconButton'
import CommonImage from '@components/common/CommonImage'
import { MdClose } from 'react-icons/md'
import CommonInput from '@/components/common/CommonInput'
import CommonButton from '@/components/common/CommonButton'
import CommonModal from '../components/common/CommonModal'
import PostTitle from '../components/post/PostTitle'
import CommonDivider from '../components/common/CommonDivider'
import IngredientBlock from '../components/post/IngredientBlock'
import ReceipeBlock from '../components/post/ReceipeBlock'
import IconText from '../components/post/IconText'

function PostDetailPage({ match }) {
  const { state } = useUserContext()
  const { params } = match
  const history = useHistory()
  const [visible, setVisible] = useState(false)
  const [comment, setComment] = useState('')
  const [_state, setState] = useState({
    receipeName: '',
    image: '',
    fullName: '',
    createdAt: '',
    receipe: [],
    likes: [],
    likeCount: 0,
    isLike: false,
    likeId: '',
    comments: [],
    userId: '',
    postId: '',
    postAuthor: '',
  })

  useEffect(() => {
    const fetchPost = async () => {
      if (!state.user) {
        return <div>404</div>
      }
      const userId = state.user._id

      try {
        const { resData } = await postApi.readPost(params.id)
        const { image, createdAt, comments, likes } = resData
        const { receipeName, receipe } = JSON.parse(resData.title)
        const { fullName, _id } = resData.author
        const likeObj = likes.find(user => user.user === userId)
        const isLike = likeObj !== undefined
        const likeId = isLike ? likeObj._id : ''

        await setState({
          receipeName,
          image,
          fullName,
          createdAt,
          receipe,
          comments,
          userId,
          likes,
          likeCount: likes.length,
          isLike,
          likeId,
          postId: resData._id,
          postAuthor: _id,
        })
      } catch (error) {
        return <div>Error</div>
      }
    }
    fetchPost()
  }, [])

  // 좋아요 버튼 토글 이벤트
  const toggleLike = async () => {
    if (_state.isLike) {
      setState({
        ..._state,
        isLike: false,
        likes: _state.likes.filter(user => user.user !== state.userId),
        likeCount: _state.likeCount - 1,
      })
    } else {
      setState({
        ..._state,
        isLike: true,
        likeCount: _state.likeCount + 1,
      })
    }
  }
  // 게시글 수정 이벤트
  const editPost = () => {}
  // 게시글 삭제 이벤트
  const deletePost = async () => {
    history.replace('/user')
  }
  // 댓글창 입력 이벤트
  const changeComment = e => {
    setComment(e.target.value)
  }
  // 댓글창 작성 이벤트
  const submitComment = async () => {
    const { resData } = await postApi.createPostComment({
      comment,
      postId: _state.postId,
    })

    setState({
      ..._state,
      comments: [..._state.comments, resData],
    })

    setComment('')
  }
  // 댓글 삭제 이벤트
  const deleteComment = async commentId => {
    setState({
      ..._state,
      comments: _state.comments.filter(comment => comment._id !== commentId),
    })
  }
  const iconText = [
    {
      id: 1,
      icon: 'thumb',
      text: _state.likeCount,
      color: '#ffffff',
      onClick: toggleLike,
    },
    {
      id: 2,
      icon: 'comment',
      text: _state.comments.length,
      color: '#ffffff',
      onClick: () => setVisible(true),
    },
  ]
  return (
    <>
      <PostDetailStyle />

      {
        <CommonModal
          style={{ padding: '40px 30px' }}
          width="50%"
          height="80%"
          visible={visible}
          onClose={() => setVisible(false)}>
          {/* Header */}
          <div className="modal-header">
            <CommonText
              fontWeight="600"
              fontSize={20}
              tag="div"
              style={{ margin: 'auto 0' }}>
              댓글 {_state.comments.length}개
            </CommonText>
            <CommonIconButton
              onClick={() => setVisible(false)}
              iconButtonType="close"
              width={35}
              height={35}
            />
          </div>
          {/* Body */}
          {_state.comments.map(comment => (
            <div className="body" key={comment._id}>
              <CommonImage
                width={50}
                height={50}
                style={{ borderRadius: '100%', marginRight: '10px' }}
                src="https://picsum.photos/200"
              />
              <div style={{ margin: 'auto 0' }}>
                <CommonText
                  className="margin-text"
                  color="black"
                  fontWeight="400"
                  fontSize={16}
                  tag="span">
                  {comment.author.fullName}
                </CommonText>
                <CommonText
                  className="margin-text"
                  color="#ABAFB4"
                  fontWeight="600"
                  fontSize={14}
                  tag="span">
                  {comment.createdAt}
                </CommonText>
                <CommonText
                  className="margin-text"
                  color="black"
                  fontWeight="400"
                  fontSize={16}
                  tag="p"
                  style={{ marginTop: '10px' }}>
                  {comment.comment}
                </CommonText>
                {comment.author._id === _state.userId && (
                  <CommonIconButton
                    onClick={() => deleteComment(comment._id)}
                    className="comment-close-btn"
                    iconButtonType="close"
                    width={20}
                    height={20}
                  />
                )}
              </div>
            </div>
          ))}
          {/* Footer */}
          <div className="modal-footer">
            <CommonInput
              key="modal-input"
              width={500}
              placeholder="댓글을 입력해보세요!"
              onChange={changeComment}
              value={comment}
              type="text"
            />
            <CommonButton
              text="게시"
              width={100}
              height="46px"
              backgroundColor="#FFFFFF"
              fontSize={16}
              onClick={submitComment}
              color="#ffa34b"
              style={{ border: '1px solid #eaebec' }}
            />
          </div>
        </CommonModal>
      }
      <div className="p30">
        <PostTitle
          title={_state.receipeName}
          fullName={_state.fullName}
          createdAt={_state.createdAt}
        />
      </div>
      <ImageContainer>
        <CommonImage
          width="50%"
          block
          mode="cover"
          style={
            _state.image
              ? { marginBottom: '5px' }
              : { border: '1px solid #EAEBEC', marginBottom: '5px' }
          }
          src={_state.image || require('../assets/images/404_wide.png').default}
        />
      </ImageContainer>

      <CommonDivider type="horizontal" size={40} />
      <div className="p30">
        <IngredientBlock>주재료</IngredientBlock>
      </div>

      <div className="p30">
        <IngredientBlock>보조재료</IngredientBlock>
      </div>

      <CommonDivider type="horizontal" size={40} />

      <div className="p30">
        <ReceipeBlock receipe={_state.receipe} readOnly="readOnly" />
      </div>

      <Footer>
        <div className="flex">
          <div>
            {_state.postAuthor === _state.userId && (
              <>
                <CommonText style={{ marginRight: '20px' }} color="#ffffff">
                  수정
                </CommonText>
                <CommonText color="#ffffff" onClick={deletePost}>
                  삭제
                </CommonText>
              </>
            )}
          </div>
          <div>
            <IconText iconText={iconText} />
          </div>
        </div>
      </Footer>
    </>
  )
}

const Footer = styled.div`
  width: 100%;
  background-color: #ffa34b;
  height: 80px;
  margin-top: 20px;
  padding: 30px;
  box-sizing: border-box;
`

const PostDetailStyle = createGlobalStyle`
  header {
  padding: 0 30px;
}
.p30 {
  padding: 0 30px;
}
.container {
  padding-left: 0;
  padding-right: 0;
  position: relative;
}
.flex {
  display: flex;
  justify-content: space-between;
}
.modal-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 80px;
  }

  .body {
    position: relative;
    display: flex;
    flex-direction: row;
    margin-bottom: 30px
  }

  .modal-footer {
    display: flex;
    flex-direction: row;
    gap: 0px 10px;
  }
  .margin-text {
      margin: 0 5px;
  }
  .comment-close-btn {
    position: absolute;
    right: 10px;
    top: 15px;
  }
`

const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export default PostDetailPage
